// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".precise-price-app .top-bar--25KuT{background-color:var(--primary-color);display:flex;align-items:center;padding:5px 5px 5px 10px;flex-shrink:0}.precise-price-app .top-bar__divider--3SRxq{width:1px;height:40px;margin:0 5px;opacity:.3;background-color:#fff}.precise-price-app .top-bar--25KuT .push-right--2WWJ4{margin-left:auto;display:flex}", ""]);
// Exports
exports.locals = {
	"topBar": "top-bar--25KuT",
	"topBarDivider": "top-bar__divider--3SRxq",
	"pushRight": "push-right--2WWJ4"
};
module.exports = exports;
